import { supabase } from './supabaseClient';

const GENERATED_PROMPTS_TABLE = 'ml_generated_prompts';

function createPromptId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `prompt_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

export const saveGeneratedPrompt = async (payload) => {
  const row = {
    id: payload.id || createPromptId(),
    user_id: payload.userId,
    type: payload.type || 'project',
    generation_mode: payload.generationMode || 'implementation',
    context: payload.context || {},
    input_summary: payload.inputSummary || {},
    prompt_asset_key: payload.promptAssetKey || null,
    generated_prompt: payload.generatedPrompt,
    llm_model: payload.llmModel || null,
    metadata: payload.metadata || {},
  };

  const { data, error } = await supabase
    .from(GENERATED_PROMPTS_TABLE)
    .upsert(row)
    .select()
    .single();

  return { data, error };
};

export const listGeneratedPrompts = async ({
  userId,
  type = null,
  courseId = null,
  projectId = null,
}) => {
  let query = supabase
    .from(GENERATED_PROMPTS_TABLE)
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (type) query = query.eq('type', type);
  if (courseId) query = query.eq('context->>courseId', String(courseId));
  if (projectId) query = query.eq('context->>projectId', String(projectId));

  const { data, error } = await query;
  return { data: data || [], error };
};

export const getGeneratedPrompt = async (promptId) => {
  const { data, error } = await supabase
    .from(GENERATED_PROMPTS_TABLE)
    .select('*')
    .eq('id', promptId)
    .single();

  return { data, error };
};
